import { isNil } from 'lodash';
import { PromoCodeFieldsFragment } from 'src/gqlReactTypings.generated.d';
/*
 * Take an array of promo codes to determine which is the highest value based on the following criteria
 *   1. Highest single value
 *   2. If tied, highest number of uses
 *   3. If tied, it doesn't matter which one is used so we just use the latest one
 *   4. % codes are not considered since we can't determine their potential $ value without a subtotal
 *      - They will still be compared, but they are unlikely to win out unless the array consists of only % codes
 */
export const getHighestValuePromo = (promoCodes: PromoCodeFieldsFragment[]) => {
  // Not really considering % codes unless they are the only ones remaining
  let highestValuePromo = promoCodes[0];

  promoCodes.forEach((code) => {
    if (code.value > highestValuePromo.value) {
      // if current code is higher value, set current as highestValue
      highestValuePromo = code;
    } else if (code.value === highestValuePromo.value) {
      // if code is equal value, check to see which has more uses
      if (isNil(code.maxUsesPerUser)) {
        // if the current code has nil max uses, it means unlimited so we set that
        // even if the current highestValue also has unlimited it's a tie so it doesn't matter which one is applied
        highestValuePromo = code;
      } else if (isNil(highestValuePromo.maxUsesPerUser)) {
        // do nothing, current highestValue is the highest value so far
      } else if (code.maxUsesPerUser > highestValuePromo.maxUsesPerUser) {
        // if the current code has more uses than highestValue (both non-null), set current as highestValue
        highestValuePromo = code;
      }
    }
  });

  return highestValuePromo;
};
